import modules_select from './select/index.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    modules:{
        select: modules_select,
    },
}